import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export default function MobileHeader({ theme, toggleTheme, onMenu }) {
  return (
    <header className="lg:hidden sticky top-0 z-30 bg-white dark:bg-dark-card px-4 py-3 flex items-center justify-between">
      {/* Hamburger */}
      <button onClick={onMenu} className="text-2xl">
        <FontAwesomeIcon icon={["fas", "bars"]} />
      </button>

      <h1 className="font-bold uppercase text-lg ml-[-1.5rem]">Imagenerate</h1>

      {/* Theme toggle */}
      <div></div>
    </header>
  );
}
